import { useCallback, useEffect, useState } from 'react';
import useIsLgBreakpoint from '../../services/useIsLgBreakpoint';

const OVERLAY_MENU = 'menu';
const OVERLAY_SEARCH = 'search';
const ESCAPE_KEY = 'Escape';

function useHeaderOverlay() {
    const [activeOverlay, setActiveOverlay] = useState(null);
    const isDesktop = useIsLgBreakpoint();

    const effectiveActive = isDesktop ? null : activeOverlay;

    const openMenu = useCallback(() => setActiveOverlay(OVERLAY_MENU), []);
    const openSearch = useCallback(() => setActiveOverlay(OVERLAY_SEARCH), []);
    const close = useCallback(() => setActiveOverlay(null), []);

    const toggleMenu = useCallback(() => {
        setActiveOverlay(current => (current === OVERLAY_MENU ? null : OVERLAY_MENU));
    }, []);

    useEffect(() => {
        if (isDesktop && activeOverlay !== null) {
            setActiveOverlay(null);
        }
    }, [isDesktop, activeOverlay]);

    useEffect(() => {
        if (effectiveActive === null) {
            return undefined;
        }

        const handleKeyDown = (event) => {
            if (event.key === ESCAPE_KEY) {
                setActiveOverlay(null);
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [effectiveActive]);

    useEffect(() => {
        if (effectiveActive === null) {
            return undefined;
        }

        const { body } = document;
        const previousOverflow = body.style.overflow;
        body.style.overflow = 'hidden';

        return () => {
            body.style.overflow = previousOverflow;
        };
    }, [effectiveActive]);

    return {
        activeOverlay: effectiveActive,
        isMenuOpen: effectiveActive === OVERLAY_MENU,
        isSearchOpen: effectiveActive === OVERLAY_SEARCH,
        openMenu,
        openSearch,
        toggleMenu,
        close,
    };
}

export default useHeaderOverlay;
